import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row, Col, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from 'containers/Offer/reducer';
import saga from 'containers/Offer/saga';

import RightSideModal from '../Modal/right';



import './customer.scss';

import * as Validator from '../CarQuote/validator';
import { CONTRACTUAL_CATEGORIES } from '../CarQuote/constants';
import {
  makeSelectQuotationCode,
  makeSelectQuote,
} from '../CarQuote/selectors';
import { sendQuote } from 'containers/Offer/actions';
import { resetCustomer } from './actions';
import { displayAssistant } from 'containers/Quotation/actions';
import {
  makeSelectOfferSelector,
  makeSelectServicesSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
  makeSelectMonthlyRateSelector,
} from '../CustomizeOffer/selectors';


class CustomerForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: { ...props.customer },
      error: {
        first_name: false,
        last_name: false,
        email: false,
        phone: false,
        zip_code: false,
        employee_category: false,
        fiscal_code: false,
        vat_number: false,
        business_name: false,

        deposit: false,
        duration: false,
        distance: false,

        franchise_kasko: false,
        franchise_insurance: false,
      },
      isComplete: false,
      submitted: false,
      submitting: false,
      redirectTo: false,
    };

    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.emailRef = React.createRef();
    this.phoneRef = React.createRef();
    this.postalRef = React.createRef();
    this.categoryRef = React.createRef();
    this.fiscalRef = React.createRef();
    this.vatRef = React.createRef();
  }

  onFirstNameChange = e => {
    const first_name = e.target.value;
    this.setState(prevState => ({
      customer: { ...prevState.customer, first_name },
    }));
  };

  onLastNameChange = e => {
    const last_name = e.target.value;
    this.setState(prevState => ({
      customer: { ...prevState.customer, last_name },
    }));
  };

  onEmailChange = e => {
    const email = e.target.value.trim();
    this.setState(prevState => ({
      customer: { ...prevState.customer, email },
    }));
  };

  onPhoneChange = e => {
    const input_phone = e.target.value;
    const phone = input_phone.replace('+39', '');
    this.setState(prevState => ({
      customer: { ...prevState.customer, phone: phone.trim() },
    }));
  };

  onFiscalCodeChange = e => {
    const fiscal_code = e.target.value.trim().toUpperCase();
    this.setState(() => ({ fiscal_code }));
    this.setState(prevState => ({
      customer: { ...prevState.customer, fiscal_code },
    }));
  };

  onPostalCodeChange = e => {
    const zip_code = e.target.value.trim();
    this.setState(prevState => ({
      customer: { ...prevState.customer, zip_code },
    }));
  };

  onVatNumberChange = e => {
    const vat_number = e.target.value.trim();
    this.setState(prevState => ({
      customer: { ...prevState.customer, vat_number },
    }));
  };

  onBusinessNameChange = e => {
    const business_name = e.target.value;
    this.setState(prevState => ({
      customer: { ...prevState.customer, business_name },
    }));
  };

  onEmployeeCategoryChange = e => {
    const employee_category = e.target.value;
    const dataset = e.target.options[e.target.selectedIndex].dataset;
    const employee_type = dataset.employeetype;
    const employee_secondary_type = dataset.secondaryemployeetype;

    this.setState(prevState => ({
      customer: {
        ...prevState.customer,
        employee_category,
        employee_type,
        employee_secondary_type,
      },
    }));
  };

  onNotesChange = e => {
    const note = e.target.value.trim();
    this.setState(prevState => ({ customer: { ...prevState.customer, note } }));
  };

  validatePhone = () => {
    const phone = this.state.customer.phone;
    const isValid = Validator.validatePhone(phone);
    this.setState(prevState => ({
      error: { ...prevState.error, phone: !isValid },
    }));

    return isValid;
  };

  validate = (condition, field) => {
    let isValid = true;
    if (condition) isValid = false;
    this.setState({
      error: {
        ...this.state.error,
        [field]: !isValid,
      },
    });
    return isValid;
  };

  isValid() {
    let valid = true;
    const errors = {};
    const { customer } = this.state;

    if (customer.first_name.length < 1) {
      valid = false;
      errors.first_name = true;
    }

    if (customer.last_name.length < 1) {
      valid = false;
      errors.last_name = true;
      this.scrollTo(this.lastNameRef);
    }

    if (!Validator.validateEmail(customer.email)) {
      valid = false;
      errors.email = true;
      this.scrollTo(this.emailRef);
    }

    if (!Validator.validatePhone(customer.phone)) {
      valid = false;
      errors.phone = true;
      this.scrollTo(this.phoneRef);
    }

    if (!Validator.validatePostalCode(customer.zip_code)) {
      valid = false;
      errors.zip_code = true;
      this.scrollTo(this.postalRef);
    }

    if (!customer.employee_category) {
      valid = false;
      errors.employee_category = true;
      this.scrollTo(this.categoryRef);
    }

    if (!Validator.validateFiscalCode(customer.fiscal_code)) {
      valid = false;
      errors.fiscal_code = true;
      this.scrollTo(this.fiscalRef);
    }

    if (
      customer.employee_type === 'BUSINESS' &&
      !Validator.validateVatNumber(customer.vat_number)
    ) {
      valid = false;
      errors.vat_number = true;
      this.scrollTo(this.vatRef);
    }

    if (
      customer.employee_secondary_type === 'BUSINESS' &&
      customer.business_name.length < 1
    ) {
      valid = false;
      errors.business_name = true;
    }

    this.setState(() => ({ error: errors }));
    return valid;
  }

  handleOnSendClick = e => {
    e.preventDefault();
    if (this.isValid()) {
      const { customer } = this.state;
      const {
        selectedOffer: offer,
        accessories,
        newMonthlyRate,
        colors,
      } = this.props;
      this.setState({ submitting: true });
      const quote = {
        code: offer.ref,
        selectedPrice: false,
        // Customer
        first_name: customer.first_name,
        last_name: customer.last_name,
        email: customer.email,
        phone: customer.phone,
        zip_code: customer.zip_code,

        // Employee
        employee_category: customer.employee_category,
        employee_type: customer.employee_type,
        fiscal_code: customer.fiscal_code,
        vat_number: customer.vat_number,
        company_name: customer.business_name,

        // Offer
        deposit: offer.deposit,
        duration: offer.duration,
        distance: offer.distance,
        note: customer.note,
        upload_documents: true,
        monthly_rate: newMonthlyRate,
        accessories,
        colors,
      };
      this.setState({ quote });
      if (!this.state.submitting) {
        this.props.sendQuote(quote);
        // this.props.displayAssistant(true) disativazione del salesbot su richiesta degli agenti
        this.props.displayAssistant(false);
        // reset customer informations
        // this.props.resetCustomer();
      }
    } else {
      this.scrollToValidate();
    }
  };

  scrollTo = ref => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  scrollToValidate = () => {
    if (this.state.error.first_name) {
      this.scrollTo(this.firstNameRef);
    } else if (this.state.error.last_name) {
      this.scrollTo(this.lastNameRef);
    } else if (this.state.error.email) {
      this.scrollTo(this.emailRef);
    } else if (this.state.error.phone) {
      this.scrollTo(this.phoneRef);
    } else if (this.state.error.zip_code) {
      this.scrollTo(this.postalRef);
    } else if (this.state.error.employee_category) {
      this.scrollTo(this.categoryRef);
    } else if (this.state.error.fiscal_code) {
      this.scrollTo(this.fiscalRef);
    } else if (this.state.error.vat_number) {
      this.scrollTo(this.vatRef);
    }
  };

  componentDidMount() {
    if (this.state.customer.email.length < 1)
      this.setState(prevState => ({
        customer: { ...prevState.customer, fiscal_code: this.props.fiscalCode },
      }));
  }

  componentDidUpdate(prevProps) {
    if (this.props.quotationCode !== prevProps.quotationCode) {
      this.setState({ redirectTo: this.props.quotationCode });
    }
  }

  render() {
    const { error, customer } = this.state;
    if (this.state.redirectTo !== false) {
      this.props.history.push(`/quotations/${this.state.redirectTo}`);
    }
    return (
      <div id="CustomerForm" className="form">
        <div className="form-background">
          <Row>
            <Col md={6} sm={6}>
              <label htmlFor="first_name" ref={this.firstNameRef}>
                Nome
              </label>
              <Input
                invalid={error.first_name}
                name="first_name"
                id="first_name"
                placeholder="Nome"
                value={customer.first_name}
                onChange={this.onFirstNameChange}
                autoComplete="off"
                onBlur={() =>
                  this.validate(customer.first_name.length < 1, 'first_name')
                }
              />
            </Col>
            <Col md={6} sm={6}>
              <label htmlFor="last_name" ref={this.lastNameRef}>
                Cognome
              </label>
              <Input
                name="last_name"
                id="last_name"
                className={error.last_name === true ? 'has-error' : ''}
                invalid={error.last_name}
                placeholder="Cognome"
                value={customer.last_name}
                onChange={this.onLastNameChange}
                autoComplete="off"
                onBlur={() =>
                  this.validate(customer.last_name.length < 1, 'last_name')
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={6}>
              <div className="FormField FieldAutocomplete" ref={this.emailRef}>
                <label>Email</label>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  invalid={error.email}
                  placeholder="E-Mail"
                  value={customer.email}
                  onChange={this.onEmailChange}
                  autoComplete="off"
                  onBlur={() =>
                    this.validate(
                      !Validator.validateEmail(customer.email),
                      'email',
                    )
                  }
                />
              </div>
            </Col>

            <Col md={6} sm={6}>
              <label htmlFor="phone" ref={this.phoneRef}>
                Telefono
              </label>
              <Input
                type="tel"
                name="phone"
                id="phone"
                invalid={error.phone}
                placeholder="Cellulare"
                value={customer.phone}
                onChange={this.onPhoneChange}
                autoComplete="off"
                onBlur={() => this.validatePhone()}
              />
            </Col>
          </Row>
          <Row>
            <Col md={8} sm={8}>
              <label htmlFor="fiscal_code" ref={this.fiscalRef}>
                Codice Fiscale&nbsp;
              </label>
              <Input
                name="fiscal_code"
                id="fiscal_code"
                invalid={error.fiscal_code}
                placeholder="Codice Fiscale"
                value={customer.fiscal_code}
                onChange={this.onFiscalCodeChange}
                onBlur={() =>
                  this.validate(
                    !Validator.validateFiscalCode(customer.fiscal_code),
                    'fiscal_code',
                  )
                }
              />
            </Col>
            <Col md={4} sm={4}>
              <label htmlFor="zip_code" ref={this.postalRef}>
                CAP
              </label>
              <Input
                type="tel"
                invalid={error.zip_code}
                name="zip_code"
                id="zip_code"
                placeholder="CAP"
                value={customer.zip_code}
                onChange={this.onPostalCodeChange}
                autoComplete="off"
                onBlur={() =>
                  this.validate(
                    !Validator.validatePostalCode(customer.zip_code),
                    'zip_code',
                  )
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12}>
              <div className="FormField">
                <label htmlFor="employee_category" ref={this.categoryRef}>
                  Occupazione&nbsp;
                </label>
                <Input
                  type="select"
                  name="employee_category"
                  autoComplete="off"
                  value={customer.employee_category}
                  onChange={this.onEmployeeCategoryChange}
                >
                  {CONTRACTUAL_CATEGORIES.map(item => (
                    <option
                      key={item.value}
                      value={item.value}
                      data-employeetype={item.type}
                      data-secondaryemployeetype={item.secondaryType}
                    >
                      {item.description}
                    </option>
                  ))}
                </Input>
              </div>
            </Col>
          </Row>

          {customer.employee_type === 'BUSINESS' && (
            <Row>
              {customer.employee_secondary_type === 'BUSINESS' && (
                <Col md={6} sm={6}>
                  <label htmlFor="business_name">Ragione Sociale</label>
                  <Input
                    invalid={error.business_name}
                    name="business_name"
                    id="business_name"
                    placeholder="Ragione Sociale"
                    value={customer.business_name}
                    onChange={this.onBusinessNameChange}
                    onBlur={() =>
                      this.validate(
                        customer.business_name.length < 1,
                        'business_name',
                      )
                    }
                    autoComplete="off"
                  />
                </Col>
              )}
              <Col md={6} sm={6}>
                <label htmlFor="vat_number" ref={this.vatRef}>
                  P.IVA&nbsp;
                </label>
                <Input
                  name="vat_number"
                  id="vat_number"
                  placeholder="P.IVA"
                  className={error.vat_number === true ? 'has-error' : ''}
                  invalid={error.vat_number}
                  value={customer.vat_number}
                  onChange={this.onVatNumberChange}
                  autoComplete="off"
                  onBlur={() =>
                    this.validate(
                      !Validator.validateVatNumber(customer.vat_number),
                      'vat_number',
                    )
                  }
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12} sm={12}>
              <label htmlFor="notes" ref={this.notesRef}>
                Note
              </label>
              <Input
                type="textarea"
                name="text"
                rows={4}
                id="notes"
                autoComplete="off"
                placeholder={
                  "Elenca le modifiche da apportare all'offerta, ad esempio: anticipo €3.000, kasko €0, pneumatici invernali, ecc."
                }
                onChange={this.onNotesChange}
                value={customer.notes}
              />
            </Col>
          </Row>
        </div>
        <div className="text-center">
          <button
            className="btn-action"
            type="button"
            onClick={this.handleOnSendClick}
          >
            {messages.action.defaultMessage}
          </button>
        </div>
        <FormattedMessage {...messages.terms} tagName="p" />
      </div>
    );
  }
}

CustomerForm.defaultProps = {
  customer: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    fiscal_code: '',
    zip_code: '',
    employee_category: 'tempo-indeterminato',
    employee_type: 'PRIVATE',
    employee_secondary_type: 'PRIVATE',
    vat_number: '',
    business_name: '',
    note: '',
  },
};

CustomerForm.propTypes = {
  customer: PropTypes.object,
  fiscalCode: PropTypes.string.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    sendQuote: quote => dispatch(sendQuote(quote)),
    displayAssistant: display => dispatch(displayAssistant(display)),
    resetCustomer: () => dispatch(resetCustomer()),
  };
}
const mapStateToProps = createStructuredSelector({
  quote: makeSelectQuote(),
  quotationCode: makeSelectQuotationCode(),
  selectedOffer: makeSelectOfferSelector(),
  newMonthlyRate: makeSelectMonthlyRateSelector(),
  services: makeSelectServicesSelector(),
  accessories: makeSelectAccessoriesCodesSelector(),
  colors: makeSelectColorCodesSelector(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
const withReducer = injectReducer({ key: 'offer', reducer });
const withSaga = injectSaga({ key: 'offer', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(RightSideModal(withRouter(CustomerForm)));
